import { useEffect } from "react";
import { useMap } from "react-leaflet";

const ChangeMapView = ({ center }) => {
    const map = useMap();

    useEffect(() => {
        map.setView(center);
    }, [map, center])

    return null;
}

export default ChangeMapView;